/* eslint-disable eqeqeq */
const fitmentFormatted = (state) => {
    const arr = []

    if (state.data.year) arr.push(state.data.year)
    if (state.data.make) arr.push(state.data.make)
    if (state.data.model) arr.push(state.data.model)
    return arr.join(' ')
}

const fitmentFormattedSecondary = (state) => {
    const arr = []

    if (state.data.body && state.data.bodySlug !== 'n-a') arr.push(state.data.body)
    if (state.data.bed && state.data.bedSlug !== 'n-a') arr.push(state.data.bed)
    if (state.data.engine && state.data.engineSlug !== 'n-a') arr.push(state.data.engine)
    return arr.join(', ')
}

const hasSiteWideDefaultFullFitment = (state) => {
    return (
        state.defaultSelectTypes.filter((selectType) => {
            return !state.data[selectType != 'year' ? `${selectType}Slug` : selectType]
        }).length == 0
    )
}

const hasFullFitment = (state) => {
    return (
        state.requiredSelectTypes.filter((selectType) => {
            return !state.data[selectType != 'year' ? `${selectType}Slug` : selectType]
        }).length == 0
    )
}

const requiredSelectTypes = (state) => {
    return state.modal.selects.filter((select) => state.requiredSelectTypes.includes(select.type))
}

const optionalSelectTypes = (state) => {
    return state.modal.selects.filter((select) => state.optionalSelectTypes.includes(select.type))
}

const selectTypes = (state) => {
    return [...state.requiredSelectTypes, ...state.optionalSelectTypes]
}

export default {
    fitmentFormatted,
    fitmentFormattedSecondary,
    hasSiteWideDefaultFullFitment,
    hasFullFitment,
    requiredSelectTypes,
    optionalSelectTypes,
    selectTypes,
}
